export const QR_PREFIX = 'datofyqr://v1/';

// Extrae el UUID del payload del QR
export const parseQRPayload = (raw) => {
  if (raw.startsWith(QR_PREFIX)) {
    return raw.replace(QR_PREFIX, '').trim();
  }
  return null;
};
